module.exports = __webpack_public_path__ + "img/money.2e4031c0.svg";